import { createCommands } from '@tdp/common/commandHandler';
import { ILogger } from '@tdp/common/telemetry';
import { IUserPreference } from '@tdp/common/userPreferences';

import {
  IThemeReader,
  ThemePreferenceSchema,
  ThemePreference,
} from './abstractions';
import { themeSlice } from './slice';

export interface CreateThemeCommandHandlerDependencies {
  logger: ILogger;
  themePreference: IUserPreference<typeof ThemePreferenceSchema>;
  themeReader: IThemeReader;
}
export const createThemeCommandHandler = ({
  logger,
  themePreference,
  themeReader,
}: CreateThemeCommandHandlerDependencies) =>
  createCommands({
    name: 'themeCommands',
    handlers: {
      async *loadCurrentTheme() {
        const preferencePromise = themePreference.readPreference();
        const themePromise = themeReader.getTheme();
        const [preferenceResult, systemTheme] = await Promise.all([
          preferencePromise,
          themePromise,
        ]);

        const preferredTheme =
          preferenceResult.type === 'success'
            ? preferenceResult.value
            : 'default';

        if (preferenceResult.type === 'failure') {
          logger.error(
            'Failed to read the theme preference - using system theme: %s | %s',
            preferenceResult.reason,
            preferenceResult.errorMessage
          );
        }

        yield themeSlice.actions.preferredThemeChanged(preferredTheme);
        yield themeSlice.actions.systemThemeChanged(systemTheme);
      },
      async *setPreferredTheme({ theme }: { theme: ThemePreference }) {
        // first write the value to the preference storage
        await themePreference.writePreference(theme);
        yield themeSlice.actions.preferredThemeChanged(theme);
      },
    },
  });
